// import external dependencies
import "jquery";

// Jquery UI
// import 'jquery-ui/ui/core';
import "jquery-ui/ui/widget";
import "jquery-ui/ui/widgets/mouse";
import "jquery-ui/ui/widgets/draggable";
import "jquery-ui/ui/widgets/slider";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui-touch-punch/jquery.ui.touch-punch";

// import 'bs-custom-file-input';

// JQuery Validation
import "jquery-validation/dist/jquery.validate";
import "jquery-validation/dist/additional-methods";
// import './util/jqueryValidator';

// LightGallery
// import 'lightgallery/dist/js/lightgallery-all';
// import 'lightgallery/lightgallery.min';
// import 'lightgallery';
// import lightGallery from 'lightgallery';
// const lightGallery from lightGallery;

// Datepicker
import "bootstrap-datepicker/dist/js/bootstrap-datepicker";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min";

// Slick
import "slick-carousel/slick/slick.min";

// Bootstrap Select
import "bootstrap-select/dist/js/bootstrap-select";

// Import everything from autoload
import "./autoload/_0_validation.js"; import "./autoload/_bootstrap.js"; import "./autoload/_device_forms.js"; import "./autoload/_enablegallery.js"; import "./autoload/_map.js"; import "./autoload/_modal.js"; import "./autoload/_responsive-nav.js"; import "./autoload/_slick.js"; import "./autoload/_stats.js"; import "./autoload/_user_forms.js";

// import then needed Font Awesome functionality
// import '@fortawesome/fontawesome-pro/js/all.js';
import "waypoints/lib/jquery.waypoints";

// import custom class depedencies
import "./class/EnableGoogleMaps";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js